export default __webpack_public_path__ + "static/media/picture_in_picture_alt.f71262b4.svg";